import { freeLocalizationService } from '@services/requests/freeLocalizationService';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';


export type Languages = 'en' | 'ru' | 'cn' | 'es';
const languages: Languages[] = ['ru', 'en', 'cn', 'es'];

const bundle = await freeLocalizationService().LoadWidgetLocalization({ langs: languages });

i18n
  .use(initReactI18next)
  .init({
    // @ts-ignore
    resources: bundle ? bundle : undefined,
    lng: languages,
    fallbackLng: 'ru',
    supportedLngs: languages,
    ns: [
      'Actions',
	  "AdditionalService",
      'AppSettings',
      'BenefitsOfWorking',
      'BenefitsOfWorkingProfile',
      'CartAsideBlock',
      'CartComponent',
      'CartSummary',
      'Common',
      'CustomsCalculator',
      'DeliveryForm',
      'DeliveryItem',
      'EmptyStyleSelect',
      'FilterComponent',
      'FooterBottomBar',
      'LocationSelector',
      'OfferContainers',
      'OfferDetail',
      'OfferTipsText',
      'OrderForm',
      'OrderList',
      'PageNames',
      'RoutesCalculationWidget',
      'RoutesListComponent',
      'SortComponent',
      'TubsContainer',
      'TYOrder',
      'CustomsPayments',
      'CompanyProfile',
    ], // Убедитесь, что указаны все ваши namespaces (если есть)
    debug: false, // Включите логирование для разработки
    defaultNS: 'Common', // Установите ваш default namespace (если есть)
    interpolation: {
      // Установите опции интерполяции
      escapeValue: false, // Не обрабатывать HTML-теги
    },
    react: {
      useSuspense: false, // Установите флаг для использования Suspense для ожидания загрузки локализации
      wait: true, // Установите флаг для ожидания загрузки локализации перед рендерингом
    },
  });


export default i18n;
